<template>
    <div class="taskTree">
        <ul class="ul-wrapper">
            <li v-for="(item,index) in list" class="li-wrapper" :class="[item.courseType == 0?`courseNodeName${item.level}`:'',{courseNodeName1:item.homeworkName,courseLi:item.courseType === 0,liActive:currentlyPlay &&  currentlyPlay.id === item.id}]" :key="item.key">
                <div class="content" :class="[{'content-Name':item.contentName&&item.type,courseNodeName:item.courseType == 0,line:item.isShow,OfflineTrain:item.type === 8}]" :style="item.isShow && item.type === 8 ? 'margin-bottom: 32px' : ''" @click="nodeClick(item,true)">
                    <div class="content-left">
                      <div class="top-title" :class="{'course-title':item.courseType === 0}">
                          <!-- 任务内容标签 -->
                          <p v-if="item.type!==1 && item.type" class="label" :class="{lockLabel:item.isLocked,trainLabel:item.type === 8}">
                              {{ConstData.taskContentType[item.type].text}}
                          </p>
                          <!-- <p v-if="item.type ==1 && item.isTraining" class="label" :class="{lockLabel:item.isLocked}">
                              线下实训
                          </p> -->
                          <!-- 课程标签 -->
                          <p v-if="item.courseType" class="course-icon" :class="{lockStyle:item.isLocked}">
                              <svg-icon :icon-class="ConstData.courseType[item.courseType].icon"></svg-icon>
                          </p>
                          <p v-if="item.homeworkName" class="course-homework-icon">
                              <svg-icon icon-class="course-zy"></svg-icon>
                          </p>

                          <h1 class="name" v-show="item.type || item.courseType || item.courseType == 0 || item.homeworkName" :class="{stageName:item.stageName,stageName1:item.stageName && !item.isTraining,contentName:item.contentName,courseNode:item.courseType === 0,courseName: item.courseId || item.homeworkName,lockStyl:item.isLocked}">{{item.stageName || item.contentName || item.name || item.homeworkName}}</h1>

                          <span class="course-status" v-if="item.isLocked">
                              <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                          </span>
                          <span class="icon-container" v-show="item.childItemList && item.childItemList.length">
                              <svg-icon icon-class="arrow-icon" :class="item.isShow ? 'down' : 'up'" class-name="arrow-icon"></svg-icon>
                          </span>
                          <!-- 线下实训 -->
                          <div class="OfflineTranin-box" v-if="item.trainingType">
                              <div class="OfflineTranin-left" :class="{OfflineTraninJeishu:(getNowFormatTime() > (item.endTime && (item.endTime.split(' ')[0]+' '+item.endTime.split(' ')[2]) )),OfflineTraninweikaishi:(getNowFormatTime() < (item.startTime && (item.startTime.split(' ')[0]+' '+item.startTime.split(' ')[2]) ))}">
                                  <p class="circle"></p>
                                  <p class="line"></p>
                              </div>
                              <div class="OfflineTranin-right">
                                  <div class="date">{{item.timeStamp}}</div>
                                  <div class="train-content" :class="{delBottomRadius:(item.signInTime&&item.signBackTime) || item.trainingType === 2}">
                                      <h2 class="name">{{item.courseName || item.examName}}</h2>
                                      <p class="add p1"><span>地点：</span>{{item.address}}</p>
                                      <p class="qiandaoTime p1" v-if="item.signInTime || getNowFormatTime() > item.signInEndTime"><span>签到时间：</span>{{item.signInTime || '--'}}</p>
                                      <p class="qiantuioTime p1" v-if="item.signBackTime || getNowFormatTime() > item.signBackEndTime"><span>签退时间：</span>{{item.signBackTime || '--'}}</p>
                                  </div>

                                  <div class="btn-box" v-if="item.trainingType === 1 && ((getNowFormatTime() >= item.signInStartTime && getNowFormatTime() <= item.signInEndTime) && !item.signInTime )" @click="offlineTrainButton(item,index,1)">
                                      <p class="btn" >扫码签到</p>
                                  </div>
                                  <div class="btn-box" v-if="item.trainingType === 1 && (getNowFormatTime() >= item.signBackStartTime && getNowFormatTime() <= item.signBackEndTime) && !item.signBackTime" @click="offlineTrainButton(item,index,2)">
                                      <p class="btn" >扫码签退</p>
                                  </div>
                                  <div class="canvas-box" ref="canvasBox">
                                      <span class="icon" @click="cancelCanvas">
                                          <van-icon name="clear" color="#ddd" />
                                      </span>
                                      <canvas class="canvas" ref="canvas"></canvas>
                                  </div>
                                  <div class="btn-box" v-if="item.trainingType === 2" @click="offlineTrainButton(item,index)">
                                      <p class="btn" v-if="item.trainingType === 2" :style="item.examButton === 3 || item.examButton === 0  ? 'color:#999' : 'color:#316FFF' ">{{item.examButton === 0 || item.examButton === 1 ? '开始考试' : item.examButton === 2 ? '已结束':'查看成绩'}}</p>
                                  </div>
                              </div>

                          </div>
                      </div>
                      <div class="bottom-info">
                          <p class="course-time" v-if="item.type===3">{{item.isLimitTime===1?formatTime(item.contentStartTime)+' ~ '+formatTime(item.contentEndTime):'长期有效'}}</p>
                          <p class="course-time" v-if="item.type === 4">{{formatTime(item.contentStartTime)+' ~ '+formatTime(item.contentEndTime)}}</p>
                          <p class="course-time" v-if="item.type===6 && item.contentEndTime">结束时间:{{formatTime(item.contentEndTime)}}</p>

                          <div class="course-info" v-if="item.type === 2">
                              <!-- 后期加 -->
                              <!-- <p class="progress">进度 · <span class="text">已完成 <span class="num">8</span>/12</span></p> -->
                              <p class="progress">进度 · <span class="text">已完成 <span class="num">{{item.studyProcess || 0}}%</span></span></p>
                              <span>｜</span>
                              <p class="infoBtn" @click.stop="courseClick(item)">课程介绍</p>
                              <!-- <span v-if="item.homeworkId">｜</span>
                              <p class="infoBtn" v-if="item.homeworkId" @click="homeworkClick(item)">作业</p> -->
                          </div>
                          <p :class="item.isLocked ? 'course-status1':( item.submitStatus ? 'course-status' : 'course-status2')" class="courseType6" v-if="item.type===6">
                              {{item.submitStatus ? '已填写' : '未填写'}}
                          </p>
                          <!-- 线下实训 -->
                          <!-- <div v-if="item.type ==1 && item.isTraining" class="Offline-training-box">
                              <div class="Offline-training" v-if="item.isReserved">
                                  <p class="order" :class="item.trainingResult === 1 ? 'color-unpass':item.trainingResult === 0?'color-pass':''">
                                      {{ConstData.trainingResult[item.trainingResult].text}}
                                  </p>
                              </div>
                              <div class="Offline-training" v-else>
                                  <p class="order" >未预约</p>
                              </div>
                              <div class="order-button" v-show="item.trainingResult != 1"  :class="!item.isTrainingCanReserve && !item.isReserved?'gray':''" >
                                  {{item.isReserved && item.trainingResult != 0?'查看预约':'预约'}}
                              </div>
                          </div> -->
                          <!-- 线下实训 end -->
                          <div class="course-content-info">
                              <p class="video-info" v-if="[1,2].includes(item.courseType)">进度·{{ (item.studyInfo && item.studyInfo.learnRate) || 0}}% | 时长· {{formateTime(item.duration)}}</p>
                              <p class="img-doc-label" v-if="[3,4,6].includes(item.courseType)">{{item.studyInfo ? '100%' : ''}}</p>
                          </div>
                          <p v-show="currentlyPlay && currentlyPlay.id === item.id" class="learn-label">继续学习</p>


                          <p @click.stop="jumpReplay(item)" class="course-status" v-if=" !item.isLocked && item.type===4 && item.isLiveReplay && item.status === 2">
                              <span class="course-live-replay">
                                  <svg-icon icon-class="course-live-replay" class-name="live-icon"></svg-icon>
                              </span>
                              <span class="live-replay-text">看回放</span>
                          </p>

                      </div>
                    </div>

                    <div class="examButton" v-if="item.type === 3">进入考试</div>
                </div>
                <taskTree v-if="item.isShow" :currentlyPlay="currentlyPlay" :taskInfo="taskInfo" :TrainBasicInfo="TrainBasicInfo" :list="item.childItemList"></taskTree>
            </li>
        </ul>
        <!-- 课程介绍弹窗 -->
        <van-dialog v-model="isCourseDialog" className="CourseDialog" :show-confirm-button="false">
            <div class="course-dialog-container" v-if="isCourseDialog && courseInfo">
                <div class="top">
                    <img :src="courseInfo.pic" class="pic" alt="">
                    <p class="name">{{courseInfo.name}}</p>
                </div>
                <div class="rate">
                    <div class="evaluation">
                        <div class="starbox" :style="{'width':`${size*total}vw`,'height':`${size}vw`}" style="position:relative;">
                            <!-- 暗星星 -->
                            <div class="star_box1" style="white-space: nowrap;overflow: hidden;position: absolute;">
                              <svg-icon icon-class="pfwjx1" class-name="pfwjx1" :style="{'width':`${size}vw`,'height':`${size}vw`}" v-for="star in total" :key="star+'grey'"></svg-icon>
                            </div>
                            <!-- 亮星星 -->
                            <div class="star_box2" style="white-space: nowrap;overflow: hidden;position: absolute;"
                            :style="{'width':`${rateValue / total * 100}%`}">
                                <svg-icon icon-class="pfwjx" class-name="pfwjx" :style="{'width':`${size}vw`,'height':`${size}vw`}" v-for="star in total" :key="star+'bright'"></svg-icon>
                            </div>
                        </div>
                        <p class="text">{{rateValue}}分</p>
                    </div>
                    <p class="goevaluation" :class="{scored:issubmit}" @click.stop="playboxscoreclick">
                        {{issubmit?'已评分':'未评分'}}
                    </p>
                </div>
                <div class="description">
                    <p v-html="courseInfo.description"></p>
                </div>
                <div class="btn" @click="isCourseDialog = false">
                    知道了
                </div>
            </div>
        </van-dialog>

        <!-- 评分弹窗 -->
        <scoreDialog v-if="scoreDialogVisible.show" :scoreDialogVisible="scoreDialogVisible" :info="scoreInfo" :issubmit="issubmit" />


    </div>
</template>

<script>
import taskTree from './taskTree.vue';
import scoreDialog from '../../../layout/scoreDialog.vue';
import { goLiveHome } from '../../../utils/livePlatform'; // 直播跳转
import jsQR from "jsqr";
export default {
    name:'taskTree',
    components:{taskTree,scoreDialog},

    props: {
        list: { // 所有树节点
            type: Array,
            default: () => {
                return []
            }
        },
        /** 任务详情 */
        taskInfo:{
            type:Object,
            default(){
                return {}
            }
        },
        /** 任务规则 */
        TrainBasicInfo:{
            type:Object,
            default(){
                return {}
            }
        },
        /** 课程详情 */
        courseInfo:{
            type:Object,
            default(){
                return {}
            }
        },
        // 当前节点
        currentlyPlay:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    computed: {
    },
    data(){
        return{
            isShow:false,
            scoreDialogVisible:{// 评分弹窗
                show:false,
            },
            scoreInfo:{
                title:'课程评分',
                name:'',
                scoreArr:[]
            }, // 评分需要的参数
            issubmit:false,
            rateValue:0,
            star:'4.6',//总分
            total:5,//星星总数
            size:7,//尺寸
            isCourseDialog:false, // 课程介绍弹窗
            courseId:null,
            isAnimation: true,
            timer:null,
            video: Object,
            cvsele: Object,
            canvas: Object,
            canvasBox:null,
        }
    },

    mounted(){
    },
    destroyed () {
        this.cance()
    },
    methods:{
      cancelCanvas(){
          this.canvasBox.style.display = "none";
          this.cance();
          this.video.srcObject.getTracks()[0].stop();
          this.video.src="";
      },
      getNowFormatDay(nowDate) {
          var char = "-";
          if(nowDate == null){
              nowDate = new Date();
          }
          var day = nowDate.getDate();
          var month = nowDate.getMonth() + 1;//注意月份需要+1
          var year = nowDate.getFullYear();
          //补全0，并拼接
          return year + char + this.completeDate(month) + char +this.completeDate(day);
      },
      getNowFormatTime() {
          var nowDate = new Date();
          var colon = ":";
          var h = nowDate.getHours();
          var m = nowDate.getMinutes();
          var s = nowDate.getSeconds();
          //补全0，并拼接
          return this.getNowFormatDay(nowDate) + " " + this.completeDate(h) + colon + this.completeDate(m) + colon + this.completeDate(s);
      },

      //补全0
      completeDate(value) {
          return value < 10 ? "0"+value:value;
      },
      // 线下实训跳转
      offlineTrainButton(item,index,codeSign){
          if(item.trainingType === 1){ // 课程
              // 扫码签到
              console.log(codeSign,'item.codeSign==')
              this.scanCode(codeSign,index);
          }else if(item.trainingType === 2){
              if(item.examButton === 0){
                  this.$notify({
                    type: "warning", message: "未到考试时间",
                  });
              }else if(item.examButton === 1){
                  // 判断是否抽题 跳转不同路由
                  if(item.questionId){
                      this.$router.push({
                        path:'/offlineStem',
                        query:{
                            id:item.examId,
                            questionId:item.questionId,
                            taskQuery:JSON.stringify(this.$route.query)
                        }
                      })
                  }else {
                      this.$router.push({
                        path:'/offlineTraining',
                        query:{
                            id:item.examId,
                            taskQuery:JSON.stringify(this.$route.query)
                        }
                      })
                  }

                  console.log('====跳转考试')
              }else if(item.examButton === 2){
                  this.$notify({
                    type: "warning", message: "考试已结束",
                  });
              }else if(item.examButton === 3){
                  this.$router.push({
                    path:'/offlineTraining/preview',
                    query:{
                        id:item.examUserId,
                        taskQuery:JSON.stringify(this.$route.query)
                    }
                  })
                  console.log('跳转查看成绩')
              }
          }
      },
      draw(begin, end) {
          this.canvas.beginPath();
          this.canvas.moveTo(begin.x, begin.y);
          this.canvas.lineTo(end.x, end.y);
          this.canvas.lineWidth = 3;
          this.canvas.strokeStyle = "red";
          this.canvas.stroke();
        },

        cance() {
            this.isAnimation = false;
            cancelAnimationFrame(this.timer);
            if(this.canvasBox){
              this.canvasBox.style.display = "none";
            }
            if(this.cvsele && this.cvsele.style){
                this.cvsele.style.display = "none";
            }
            console.log(this.timer,this.cvsele,'this.timer===')
            // setTimeout(() => {


            // }, 1000);
        },
        getQueryString(url,name) {
          /* eslint-disable */
          var search = "?"+url.split('?')[1];
          //alert(search);
          var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
          var matcher = pattern.exec(search);
          var items = null;
          if (null != matcher) {
              try {
                  items = decodeURIComponent(decodeURIComponent(matcher[1]));
              } catch (e) {
                  try {
                      items = decodeURIComponent(matcher[1]);
                  } catch (e) {
                      items = matcher[1];
                  }
              }
          }
          return items;
          /* eslint-disable */
        },
       async sweep(codeSign) {
         if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
            const { videoWidth, videoHeight } = this.video;
            this.cvsele.width = videoWidth;
            this.cvsele.height = videoHeight;
            this.canvas.drawImage(this.video, 0, 0, videoWidth, videoHeight);
            try {
              const img = this.canvas.getImageData(0, 0, videoWidth, videoHeight);
              this.imgurl = img;
              const obj = jsQR(img.data, img.width, img.height, {
                inversionAttempts: "dontInvert",
              });
              if (obj) {
                  const loc = obj.location;
                  this.draw(loc.topLeftCorner, loc.topRightCorner);
                  this.draw(loc.topRightCorner, loc.bottomRightCorner);
                  this.draw(loc.bottomRightCorner, loc.bottomLeftCorner);
                  this.draw(loc.bottomLeftCorner, loc.topLeftCorner);
                  if (this.result != obj.data) {
                    this.result = obj.data;
                    this.cance();
                    console.info("识别结果：", obj.data);

                    this.video.srcObject.getTracks()[0].stop();
                    this.video.src="";

                    // alert(obj.data,'obj.data')
                    if(obj.data){
                        console.log(obj.data,'obj.data2222')
                        console.log(codeSign,'item.codeSign==')
                        const data = {
                              trainingClassId:this.getQueryString(obj.data,'trainingClassId'),
                              courseId:this.getQueryString(obj.data,'id'),
                              signType:codeSign,//  1 签到 2 签退
                          }
                          console.log(data,'data====')
                          this.$api.learning.courseSign({data}).then(res => {
                              if(res.success){
                                  this.$toast({
                                      message:codeSign==1?'扫码签到成功':'扫码签退成功',
                                      className:'courseToast'
                                  });
                              }else {
                                  this.$toast({
                                      message:res.message,
                                      className:'courseToast'
                                  });
                              }
                              this.getParent(this.$parent, 'taskDetailExt');
                              // this.$parent.getTaskDetail()

                          })
                    }
                  }
              }
              // else {
              //   // this.$toast({
              //   //     message:'识别失败，请检查二维码是否正确！',
              //   //     className:'courseToast',
              //   //     duration: 1500,
              //   // });
              //   // this.cance();
              //   // this.video.srcObject.getTracks()[0].stop();
              //   // this.video.src="";
              //   console.error("识别失败，请检查二维码是否正确！");
              // }
            } catch (err) {
              this.$toast({
                  message:'识别失败，请检查二维码是否正确！',
                  className:'courseToast',
                  duration: 1500,
              });
              this.cance();
              this.video.srcObject.getTracks()[0].stop();
              this.video.src="";
              console.error("识别失败，请检查二维码是否正确！", err);
            }
          }
          if (this.isAnimation) {
            this.timer = requestAnimationFrame(() => {
              console.log('sweep======')
              this.sweep(codeSign);
            });
          }
        },
        // 扫描二维码
        /* eslint-disable */
        async scanCode(codeSign,index){
           await this.$nextTick(() => {
              this.video = document.createElement("video");

              console.log(this.$refs.canvas[index],'========')
              this.cvsele = this.$refs.canvas[index];
              console.log(this.cvsele,'cvsele-')
              this.canvas = this.cvsele.getContext("2d");
              this.canvasBox = this.$refs.canvasBox[index]

            })
             console.log(this.cvsele,'cvsele-')
            this.isAnimation = true;
            this.canvasBox.style.display = "block";
            this.cvsele.style.display = "block";
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
            if (navigator.mediaDevices) {
              navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" },
              }).then((stream) => {
                this.video.srcObject = stream;
                this.video.setAttribute("playsinline", true);
                this.video.setAttribute("webkit-playsinline", true);
                this.video.addEventListener("loadedmetadata", () => {
                  this.video.play();
                  this.sweep(codeSign);
                });
              }).catch((error) => {
                this.cance();
                alert('对不起：未识别到扫描设备!');
                console.log(error.code + "：" + error.name + "，" + error.message);
              });
            } else if (navigator.getUserMedia) {
              navigator.getUserMedia({
                  video: { facingMode: "environment" },
                }, (stream) => {
                  this.video.srcObject = stream;
                  this.video.setAttribute("playsinline", true);
                  this.video.setAttribute("webkit-playsinline", true);
                  this.video.addEventListener("loadedmetadata", () => {
                    this.video.play();
                    this.sweep();
                  });
                }, (error) => {
                  this.cance();
                  alert('对不起：未识别到扫描设备!');
                  console.log(error.code + "：" + error.name + "，" + error.message);
                }
              );
            } else {
              if (navigator.userAgent.toLowerCase().match(/chrome/) && location.origin.indexOf("https://") < 0 ) {
                console.log("获取浏览器录音功能，因安全性问题，需要在localhost 或 127.0.0.1 或 https 下才能获取权限！");
              } else {
                this.cance();
                alert("对不起：未识别到扫描设备!");
              }
            }
        },
        /** 秒换算时分秒 */
        formateTime(time) {
            const h = parseInt(time / 3600)
            const minute = parseInt(time / 60 % 60)
            const second = Math.ceil(time % 60)

            const hours = h < 10 ? '0' + h : h
            const formatSecond = second > 59 ? 59 : second
            return `${hours > 0 ? `${hours}:` : ''}${minute < 10 ? '0' + minute : minute}:${formatSecond < 10 ? '0' + formatSecond : formatSecond}`
        },
        /** 评分 */
        clickclose(){
            this.scoreDialogVisible.show=false;
            this.$forceUpdate;
        },
        playboxscoreclick(){
            if((this.courseInfo.userLearnInfo && typeof(this.courseInfo.userLearnInfo) != 'undefined') && this.courseInfo.userLearnInfo.learnRate >=30){
                this.scoreDialogVisible.show=true;
            } else {
                console.log(1111)
                this.$toast({
                    message:'课程学习进度未达到30%，不能进行评价',
                    className:'courseToast'
                });
            }
        },
        async getEvaluationInfo(){
            let params = {
                courseId: this.courseId
            }
            await this.$api.course.getEvaluationInfo({ params }).then(res => {
                if (res.data) {
                    this.rateValue=res.data.aveScore?res.data.aveScore:5;
                    this.issubmit = res.data.myScore ? true : false;
                    this.scoreInfo.name = this.courseInfo.name || '';
                    let detailInfo = res.data.detailInfo && JSON.parse(res.data.detailInfo)
                    this.scoreInfo.scoreArr = [
                        {
                          label:'课程内容',
                          count:detailInfo ? detailInfo.courseContentScore : 0,
                        },
                        {
                          label:'教学方法',
                          count:detailInfo ? detailInfo.trainMethodScore : 0,
                        },
                        {
                          label:'教学结果',
                          count:detailInfo ? detailInfo.trainEffectScore : 0,
                        }
                    ];
                    this.$forceUpdate;
                }
            });
        },
        async evaluateCourse(arr){
            console.log(arr,'arr==');

            const data = {
                courseId: this.courseId,
                // score:count,
                courseContentScore:arr[0].count,//课程内容
                trainMethodScore:arr[1].count,//教学方式
                trainEffectScore:arr[2].count,//教学效果
            }
            await this.$api.course.evaluateCourse({ data }).then(res => {
                this.clickclose()
                this.getEvaluationInfo();
            })
        },
        /**
         * 课程介绍
         */
        async courseClick(item){
            console.log(item,'item====')
            this.courseId = item.contentId;
             // 课程详情接口
            await this.getCourseInfo(item);
            console.log(this.courseInfo,'courseInfo')
            // 评分接口
            await this.getEvaluationInfo();
            this.isCourseDialog = true;


        },
        async getCourseInfo(item){
            let params = {
                courseId:item.contentId,
                taskId:this.$route.query.id,
                taskType:2
            }
            await this.$api.course.findCourseInfo({params}).then(res => {
                this.courseInfo = res.data;
            })
        },
        /**
         * 跳转 作业
         */
        homeworkClick(item){
            this.$router.push({
                path:'/homeworkList',
                query:{
                    courseId:item.contentId,
                    taskId:this.$route.query.id
                }
            })
        },
        // 直播
        jumpReplay(item) {
            console.log('观看回放')
            // && childItem1.isReplay
          this.$api.live.getBjyPlayUrl({liveCourseId: item.contentId}).then(async (resB) => {
            if(resB.data.roomStatus==1||resB.data.roomStatus==7){ // 腾讯
              if(item.isReplay){
                goLiveHome(this, item.contentId,item)
              } else {
                this.$toast('视频转码中~')
              }
            }else if(resB.data.roomStatus==2 || resB.data.roomStatus==6 || resB.data.roomStatus==4){ // 百家云 cc
              if(!item.isReplay){
                  this.$toast({
                    message:'视频转码中~',
                    duration: 3000,
                });
                return false
              }
              goLiveHome(this, item.contentId,item)

            }
          });

        },

        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.')+' '+val.split(' ')[1].split(':').slice(0,2).join(':')
            }
        },
        /** 大纲目录遍历 */
        changeArr(data,item1){
            data.forEach(item => {
                if(item1.isShow === item.isShow && item1.id === item.id){
                    item.isShow = !item.isShow;

                }else {
                    item.isShow = false;
                }
                if(item.childItemList && item.childItemList.length){
                    this.changeArr(item.childItemList,item1);

                }
            });
        },

        /** 节点点击 */
        async nodeClick(item,tag){
                this.istag = true;
            if(item.childItemList && item.childItemList.length){
                if(tag){
                    await this.changeArr(this.list,item);
                    this.$forceUpdate();
                }
            }

            this.getParent(this.$parent, 'clickNode',item);

        },
        /** 获取父组件方法 并且传值 */
        getParent(parent,fn,item) {
            if (parent[fn]) {
                parent[fn](item)
            } else {
                this.getParent(parent.$parent, fn,item)
            }
        },
        async changeShow (item) { // 点击是否展开根目录，当前状态取反即可
            await this.changeArr(this.list,item);
            this.$forceUpdate();
        },



    }
}
</script>

<style lang="less" scoped>
  @import '../css/tree2.less';

</style>
<style lang="less">
.courseToast.van-toast.van-toast--middle{
    z-index: 9999 !important;
}
</style>
